import {css} from '@emotion/css';
import {spacing, elementSize} from '@fo/shared/styles/variables';
import {Breakpoints, mq} from '@fo/shared/styles/mixins';

export default {
  container: css`
    label: subscribeToOurNewsletterSection;
    && {
      display: flex;
      justify-content: center;
    }
  `,
  contents: css`
    label: subscribeToOurNewsletterSection__contents;
    width: 100%;
    max-width: ${elementSize.container.XS};
  `,
  text: css`
    label: subscribeToOurNewsletterSection__text;
    margin-bottom: ${spacing.M};
    ${mq(Breakpoints.TABLET)} {
      text-align: center;
    }
  `,
  subtitle: css`
    label: subscribeToOurNewsletterSection__subtitle;
    color: $fontColorAssistive;
  `,
};
